import { useSelector } from "react-redux";
import { getNodeStatus } from "../redux/slice/statusSlice";

function useStatus(id) {
  const status = useSelector(getNodeStatus(id));

  return status;
}

export default useStatus;